import { render, staticRenderFns } from "./LessonsText.vue?vue&type=template&id=aff90b38&scoped=true&"
import script from "./LessonsText.vue?vue&type=script&lang=js&"
export * from "./LessonsText.vue?vue&type=script&lang=js&"
import style0 from "./LessonsText.vue?vue&type=style&index=0&id=aff90b38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff90b38",
  null
  
)

export default component.exports